import { Flex } from "@chakra-ui/react";
import { get } from "lodash";
import { PropsWithChildren } from "react";
import { useTracking } from "~/lib/hooks";
import { StrapiItineratorPage } from "~/strapi";
import { LayoutOptions } from "~/types";
import { Footer } from "./Footer/Footer";
import { Header } from "./NavHeader/Header";

export const Layout = ({
  children,
  pageData,
  layoutOptions,
}: PropsWithChildren<{
  pageData: StrapiItineratorPage;
  layoutOptions?: LayoutOptions;
}>) => {
  const { seo } = pageData || {};
  useTracking();
  const showFooter = get(layoutOptions, "showFooter", true);
  const showHeader = get(layoutOptions, "showHeader", true);
  return (
    <>
      {showHeader && <Header />}
      <Flex direction="column">{children}</Flex>
      {showFooter && pageData && <Footer />}
    </>
  );
};
